import { createSelector } from 'reselect';
import orderBy from 'lodash/orderBy';
import { RootState } from 'store/types';
import { Consumer } from 'store/profile/types';
import { currentAccountConsumerSelector } from 'store/account/selectors';
import { BookedAppointment } from 'store/booking/types';

/**
 * NOTE: We do not currently use these selectors
 * but I wanted to keep them since this section of the app is evolving
 */

const filterByConsumerId = (data: BookedAppointment[], consumer: Consumer) => {
  if (!consumer) {
    return data;
  }

  return data.filter(d => d.consumerId === consumer.consumerId);
};

export const pastAppointmentsSelector = (state: RootState) => state.booking.appointments.past;

export const pastAppointmentsFetchingSelector = createSelector(
  pastAppointmentsSelector,
  past => past.isFetching
);

export const pastAppointmentsErrorSelector = createSelector(
  pastAppointmentsSelector,
  past => past.error
);

export const pastAppointmentsDataSelector = createSelector(
  pastAppointmentsSelector,
  past => past.data
);

export const pastAppointmentsRequestStateSelector = createSelector(
  pastAppointmentsSelector,
  past => past.requestState
);

export const pastAppointmentForConsumerSelector = createSelector(
  [pastAppointmentsDataSelector, currentAccountConsumerSelector],
  (appts, account) => orderBy(filterByConsumerId(appts, account), ['appointmentDate'], ['desc'])
);
